import { render, staticRenderFns } from "./comment_list.vue?vue&type=template&id=3efcc050&scoped=true&"
import script from "./comment_list.vue?vue&type=script&lang=js&"
export * from "./comment_list.vue?vue&type=script&lang=js&"
import style0 from "./comment_list.vue?vue&type=style&index=0&id=3efcc050&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efcc050",
  null
  
)

export default component.exports